import * as React from 'react'
import { IRiderLocationObject, IRiderObject, IRiderActivityLocationObject } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import LocationList from './LocationList'
import LocationActivityList from './LocationActivityList'
import HorizontalSelector from '../../../HorizontalSelector'
import HorizontalSelectorItem from '../../../HorizontalSelectorItem'
import FloatingForm from 'src/components/ui/form/FloatingForm'

interface ILocationProps {
  rider: IRiderObject
  riderId: string
  riderLocations: IRiderLocationObject[]
  riderLocationActivities: IRiderActivityLocationObject[]
  getRiderLocationList: (riderId: string) => void
  getRiderLocationActivityList: (riderId: string) => void
}

interface ILocationPaneState {
  locationActivity: boolean
}

class LocationPane extends React.Component<ILocationProps, ILocationPaneState> {
  public state: ILocationPaneState = {
    locationActivity: false
  }

  constructor(props: ILocationProps) {
    super(props)
  }

  public componentDidMount() {
    this.props.getRiderLocationList(this.props.riderId)
    this.props.getRiderLocationActivityList(this.props.riderId)
  }

  public render() {
    return (
      <section>
        <FloatingForm fullHeight={true}>
          <div className='w100'>
            <div className='flex pb3'>
              <HorizontalSelector>
                <HorizontalSelectorItem isSelected={!this.state.locationActivity}>
                  <div className='uppercase cursor--pointer' onClick={this.toggleTab(false)}>
                    {UIMessages.rider.locations}
                  </div>
                </HorizontalSelectorItem>
                <HorizontalSelectorItem isSelected={this.state.locationActivity}>
                  <div className='uppercase cursor--pointer' onClick={this.toggleTab(true)}>
                    {UIMessages.rider.locationActivity}
                  </div>
                </HorizontalSelectorItem>
              </HorizontalSelector>
            </div>
            {!this.state.locationActivity ? (
              <div className='h4 font-grey2 bold'>
                <LocationList locations={this.props.riderLocations} />
              </div>
            ) : (
              <div className='h4 font-grey2 bold'>
                <LocationActivityList locationActivity={this.props.riderLocationActivities} />
              </div>
            )}
          </div>
        </FloatingForm>
      </section>
    )
  }

  private toggleTab = (showLocationActivity: boolean) => {
    return (e: any) => {
      this.setState({ locationActivity: showLocationActivity })
    }
  }
}

export default LocationPane



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/location/LocationPane.tsx